import * as React from "react";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PhoneIcon from "@mui/icons-material/Phone";
import { Controller } from "react-hook-form";
import IntPhoneNumberField from "./IntPhoneNumber";
import IntTelephoneNumberField from "./TelephoneMaskCustom";

export default function PhoneOrTelephoneField({
  control,
  name,
  label,
  error,
  phoneName,
  type,
  telephoneName,
}) {
  const [selectedOption, setSelectedOption] = React.useState("mobile");
  console.log("type", type);
  React.useEffect(() => {
    setSelectedOption(type || "mobile");
  }, [type]);
  return (
    <Controller
      name={name}
      control={control}
      defaultValue="mobile"
      render={({ field }) => (
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Left Side: Icon Toggle */}

          <Box sx={{ display: "flex" }}>
            <Tooltip title="Mobile Number">
              <IconButton
                color={selectedOption === "mobile" ? "primary" : "default"}
                onClick={() => {
                  setSelectedOption("mobile");
                  field.onChange("mobile");
                }}
              >
                <PhoneIphoneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Landline Number">
              <IconButton
                color={selectedOption === "telephone" ? "primary" : "default"}
                onClick={() => {
                  setSelectedOption("telephone");
                  field.onChange("telephone");
                }}
              >
                <PhoneIcon />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Right Side: Conditional Field */}
          <Box flex={1}>
            {selectedOption === "mobile" ? (
              <IntPhoneNumberField
                control={control}
                name={phoneName}
                label="Mobile Number *"
                error={error?.phone}
              />
            ) : (
              <IntTelephoneNumberField
                control={control}
                name={telephoneName}
                label="Landline Number *"
                error={error?.telephone}
              />
            )}
          </Box>
        </Stack>
      )}
    />
  );
}
